<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11" v-if="project">
            <h1>Proyecto</h1>

            <div class="form-group mt-4">
                <label for="idea_nombre">Beneficio que se obtuvo</label>

                <input type="text" class="form-control" v-model="project.beneficio" />
            </div>

            <!-- <div class="form-group mt-4">
                <label for="idea_nombre">Evidecias de respaldo</label>

                <input type="text" class="form-control" />
            </div> -->

            <div class="form-group mt-4">
                <label for="project_nombre">Criterio utilizado donde impacta</label>

                <div class="text-left">
                    <div class="custom-control custom-checkbox" v-for="choice in choices" :key="choice">
                        <input
                            type="checkbox"
                            :value="choice"
                            :id="`check-` + choice"
                            v-model="project.criterios"
                            class="custom-control-input"
                        />

                        <label class="custom-control-label" :for="`check-` + choice">{{ choice }}</label>
                    </div>
                </div>
                <!-- <input
                    v-if="project.criterios.includes('Otros')"
                    type="text"
                    class="form-control"
                    v-model="project.criterio_otros"
                /> -->
            </div>

            <button class="btn w-100 btn-light btn-lg my-4" :disabled="disabled" @click="set">Siguiente</button>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            choices: ["Costo", "Tiempo", "Calidad", "Otros"],
            ...mapGetters(["getProject"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        criterioOtros: function () {
            return this.project.criterios.includes("Otros") && this.project.criterio_otros;
        },
        disabled: function () {
            return !this.project.beneficio || this.project.criterios.length == 0;
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            router.push("Project5");
        },
        ...mapActions(["setProject"]),
    },
};
</script>
